// extracted by mini-css-extract-plugin
export default {"container":"Lane-module_container_RZdZu","task-lane":"Lane-module_task-lane_AlH3W"};